import React, { useEffect, useState } from "react";
import {
  collection,
  onSnapshot,
  query,
  orderBy,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { db } from "../firebase";
import "./Messages.css";

function Messages() {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    const q = query(
      collection(db, "contacts"), // ⚠ same collection name
      orderBy("createdAt", "desc")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setMessages(list);
    });

    return () => unsubscribe();
  }, []);

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "contacts", id));
  };

  return (
    <div className="messages-page">
      <h2 className="page-title">📩 Contact Messages</h2>

      {messages.length === 0 ? (
        <div className="empty-box">No messages yet.</div>
      ) : (
        <div className="messages-grid">
          {messages.map((msg) => (
            <div key={msg.id} className="message-card">
              
              <div className="card-header">
                <h3>{msg.name || "No Name"}</h3>
                <span>{msg.email}</span>
              </div>

              {/* ✅ Message Text Added */}
              <div className="message-body">
                <p>{msg.message}</p>
              </div>

              <div className="card-footer">
                <small>
                  {msg.createdAt?.toDate
                    ? msg.createdAt.toDate().toLocaleString()
                    : ""}
                </small>

                {/* ✅ Delete Button */}
                <button onClick={() => handleDelete(msg.id)}>
                  Delete ❌
                </button>
              </div>

            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Messages;